//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';

// Remove 'bazaarvoice sampling - single retailer' once legacy purchase options are non-existant
const SINGLE_RETAILER_SUBSTRINGS = [
  'bazaarvoice sampling - single retailer',
  'single destination',
] as const;

export const isSingleRetailerPurchaseOption = (
  purchaseOption?: PurchaseOption,
): boolean => {
  if (!purchaseOption?.sfdcProductType) {
    return false;
  }

  const sfdcProductTypeLower = purchaseOption.sfdcProductType.toLowerCase();
  return SINGLE_RETAILER_SUBSTRINGS.some((substring) =>
    sfdcProductTypeLower.includes(substring),
  );
};
